import React, { useState } from "react";

import { Button, Dialog, DialogContent, TextField } from "@material-ui/core";
import { ClipLoader } from "react-spinners";

export default function CreateShowreelPopup({
  open,
  onClose,
  loading,
  createShowreel,
}) {
  const [name, setName] = useState("");

  function onSubmit(e) {
    e.preventDefault();
    createShowreel(name);
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogContent className="popup-container">
        <h2>Create New Showreel</h2>
        <p className="dialog-text">
          Give your showreel a name for future reference.
        </p>
        <form onSubmit={onSubmit}>
          <TextField
            variant="outlined"
            autoFocus
            id="name"
            type="name"
            required
            placeholder="Showreel name..."
            fullWidth
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          <Button
            color="primary"
            type="submit"
            variant="contained"
            style={{ marginBottom: 16, marginTop: 8, float: "right" }}
          >
            {!loading ? (
              "Create Showreel"
            ) : (
              <ClipLoader size={21} color={"white"} />
            )}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
